var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { CmsTextsContext } from './CmsTextsContext';
import { cmsTextsReducer } from '../reducers';
export const CmsTextsService = ({ children, cmsTextsApi }) => {
    const reducer = useReducer(cmsTextsReducer, { status: 'not_loaded', texts: undefined });
    const [, setCmsTexts] = reducer;
    useEffect(() => {
        const fetchCmsTeksten = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setCmsTexts({ type: 'LOADING' });
                const cmsTexts = yield cmsTextsApi();
                if ([200, 201].includes(cmsTexts.status))
                    setCmsTexts({ type: 'LOADED', payload: cmsTexts.data });
            }
            catch (e) {
                console.error(`[CmsTextsService] Unable to fetch texts from Drupal. ${e}`);
                setCmsTexts({ type: 'LOADING_FAILED' });
            }
        });
        fetchCmsTeksten();
    }, []);
    return _jsx(CmsTextsContext.Provider, Object.assign({ value: reducer }, { children: children }));
};
